import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import "../App.css";
import ProfileCard from "./ProfileCard";

const Profile = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
   }, []);
  return (
    <>
      <div className="profile-card-div">
        <ProfileCard 
            imageLink={"./Images/team/anis2.png"}
            linkedinLink={"https://www.linkedin.com/in/anis-shaikh-a87496240/"}
            name={"Anis Shaikh"}
            post={"Chair"}
        />
        <ProfileCard 
            imageLink={"./Images/team/prajaktastaav.jpg"}
            linkedinLink={"https://www.linkedin.com/in/prajakta-satav110/"}
            name={"Prajakta Satav"}
            post={"Vice Chair"}
        />
        <ProfileCard 
            imageLink={"./Images/team/ksit.jpg"}
            linkedinLink={"https://www.linkedin.com/in/kshitij-thorat-2aab88259/"}
            name={"Kshitij Thorat"}
            post={"Treasurer"}
        />
        <ProfileCard 
            imageLink={"./Images/team/yashini.jpg"}
            linkedinLink={"https://www.linkedin.com/in/yashini-pardeshi-608657211/"}
            name={"Yashini Pardeshi"}
            post={"Secretary"}
        />
        
        <ProfileCard 
            imageLink={"./Images/team/yashp.jpg"}
            linkedinLink={"https://www.linkedin.com/in/yash-kishor-patil-5119ba256/"}
            name={"Yash Patil"}
            post={"Web Team Head"}
        />
        <ProfileCard 
            imageLink={"./Images/team/manasi.jpg"}
            linkedinLink={"https://www.linkedin.com/in/manasi-c-62a6b2259/"}
            name={"Manasi Choudhari"}
            post={"Design Team Head"}
        />
       <ProfileCard 
            imageLink={"./Images/team/atj.png"}
            linkedinLink={"https://www.linkedin.com/in/atharva-jadhav-5a5588257/"}
            name={"Atharva Jadhav"}
            post={"Video Editing Team Head"}
        />
           <ProfileCard 
            imageLink={"./Images/team/niraj.jpg"}
            linkedinLink={"https://www.linkedin.com/in/niraj-dhakulkar/"}
            name={"Niraj Dhakulkar"}
            post={"Content Team Head"}
        />
        <ProfileCard 
            imageLink={"./Images/team/mayank.jpg"}
            linkedinLink={"https://www.linkedin.com/in/mayank-bobade-39aa24259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"}
            name={"Mayank Bobade"}
            post={"Event Management Team Head"}
        />
        <ProfileCard 
            imageLink={"./Images/team/kedar.jpg"}
            linkedinLink={"https://www.linkedin.com/in/kedarnath-zunjare-71452b257/"}
            name={"Kedarnath Zunjare"}
            post={"Social Media Team Head"}
        />
        
        <ProfileCard 
            imageLink={"./Images/team/jayram.jpg"}
            linkedinLink={"https://www.linkedin.com/in/jayram-palwe-904a6428b/"}
            name={"Jayram Palwe"}
            post={"Inventory Head"}
        />

        <ProfileCard 
            imageLink={"./Images/team/shreeyash.jpg"}
            linkedinLink={"https://www.linkedin.com/in/shreeyash-pawar-1017b4289/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"}
            name={"Shreeyash Pawar"}
            post={"Sponsorship Team Head"}
        />  
      </div>
    </>
  );
};

export default Profile;
